import { Avatar } from '@creditornot/cb-avatar';
import { colors, cssThemedValue, typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import { areEqual } from 'react-window';
import styled, { useTheme } from 'styled-components';

import { WideAreaCheckbox } from 'common/components';

import { NAME_COLUMN_WIDTH } from './constants';
import { VenueResult } from './types';

export type VenueRowData = {
  onRowClick: (id: string) => void;
  selectedMenuIds: string[];
  venues: VenueResult[];
};

type Props = {
  index: number;
  data: VenueRowData;
  style: React.CSSProperties;
};

const Root = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
  cursor: pointer;
  width: 100vw;
  height: 100%;

  background-color: ${({ selected }) => {
    if (selected) {
      return colors.wolt4;
    }
    return cssThemedValue('surfaceMain');
  }};

  &:hover {
    background-color: ${({ selected }) =>
      selected ? colors.wolt8 : cssThemedValue({ light: colors.pepper8, dark: colors.salt4 })};
  }
`;

const VenueNameAndAvatar = styled.div`
  display: flex;
  align-items: center;
`;

const ImageContainer = styled.div`
  margin-inline-end: 12px;
  display: flex;
  align-items: center;
`;

const TableCell = styled.div`
  ${typographyCss.Body3}
  align-items: center;
  display: flex;
  padding: 0 24px;
  text-align: start;
`;

const NameCell = styled(TableCell)`
  width: ${NAME_COLUMN_WIDTH}vw;
`;

const AddressCell = styled(TableCell)``;

const VenueListRowRenderer = ({ index, data: { onRowClick, selectedMenuIds, venues }, style }: Props) => {
  const { cbDirection } = useTheme();

  const venue = venues[index];

  if (!venue.menu_id) {
    return null;
  }

  const selected = selectedMenuIds.includes(venue.menu_id);

  return (
    <Root dir={cbDirection} style={style} selected={selected} onClick={() => onRowClick(venue.menu_id!)}>
      <WideAreaCheckbox
        onToggle={() => onRowClick(venue.menu_id!)}
        selectionStatus={selected ? 'selected' : 'not-selected'}
      />
      <NameCell>
        <VenueNameAndAvatar>
          <ImageContainer>
            <Avatar size="tiny" imgSrc={venue.listimage} />
          </ImageContainer>
          {venue.name[0].value}
        </VenueNameAndAvatar>
      </NameCell>
      <AddressCell>{venue.address}</AddressCell>
    </Root>
  );
};

export default React.memo(VenueListRowRenderer, areEqual);
